import React from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {MultipleSelector} from "mindsets-js-sdk";

import {SetQuestionPracticeSkillsUpdatedAction} from "../../actions/question_actions";

function DependsOn({question}) {
    const dispatch = useDispatch();
    const questions = useSelector(state => state.questions);
    const question_practice_skills_updated = useSelector(state => state.question_practice_skills_updated);
    const selected_assignment_index = useSelector(state => state.selected_assignment_index);
    const question_practice_skill_updated = question_practice_skills_updated[selected_assignment_index];

    if (question_practice_skill_updated.mode === 'ai') {
        return (
            <div className='col-sm-4'>
                <label className='form-label'>Depends on</label>
                <MultipleSelector
                    id={'question_practice_skill-depends-' + question.code}
                    trigger={(
                        <div
                            className='bordered little'
                        >{Array.isArray(question_practice_skill_updated.questions) && question_practice_skill_updated.questions.length > 0 ? questions.filter(q => question_practice_skill_updated.questions.includes(q.code)).map(q => 'Q' + q.number).join(', ') : 'Please select'}</div>
                    )}
                    callback={selected => {
                        const question_practice_skills_updated_x = JSON.parse(JSON.stringify(question_practice_skills_updated));
                        question_practice_skills_updated_x[selected_assignment_index].questions = JSON.parse(JSON.stringify(selected));
                        dispatch(SetQuestionPracticeSkillsUpdatedAction(question_practice_skills_updated_x));
                    }}
                    item_name='Question'
                    items={questions.filter(q => parseInt(q.number) < parseInt(question.number)).map(q => ({
                        code: q.code,
                        label: 'Q' + q.number + '(v.' + q.challenge_version_number + ')'
                    }))}
                    item_id_key={'code'}
                    selected={Array.isArray(question_practice_skill_updated.questions) ? question_practice_skill_updated.questions : []}
                    disabled={questions.filter(q => parseInt(q.number) < parseInt(question.number)).length <= 0}
                    show_all_option={true}
                />
            </div>
        );
    }

    return null;
}

DependsOn.propTypes = {
    question: PropTypes.shape({
        code: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired,
        challenge_version_number: PropTypes.number.isRequired
    }).isRequired
}

export default DependsOn;
